module.exports = __webpack_public_path__ + "static/media/tex_hand2.e3e8b154.png";